
document.addEventListener("DOMContentLoaded", () => {
  tippy('a.tippy')
})